// import * as React, from "react";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";


// Import Images
import darkLogo from "../../assets/images/dark-logo.svg";
import laptopImg from "../../assets/images/auth-laptop-image.png";


// Import Icons
import googleIcon from "../../assets/images/icons/google-icon.svg";
import microsoftIcon from "../../assets/images/icons/microsoft-icon.svg";
import eyeHideIcon from "../../assets/images/icons/eye-hide-icon.svg";
import eyeViewIcon from "../../assets/images/icons/eye-view-icon.svg";

function OtcTrade() {

    const [passwordsVisibility, setPasswordsVisibility] = useState({
        userPassword: false,
        confirmPassword: false,
    });

    const togglePasswordVisibility = (field) => {
        setPasswordsVisibility((prevState) => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };


    return (
        <div className='login-page'>
            <section className="sec-auth">
                <div className="auth-banner-wrapper">
                    <span className="top-notch"></span>
                    <div className="auth-banner-card">
                        <a href="#" className="logo">
                            <img src={darkLogo} alt="logo" />
                        </a>
                        <div className="laptop-img">
                            <img src={laptopImg} alt="img" />
                        </div>
                    </div>
                </div>
                <div className="user-auth-wrapper">
                    <div className="form-wrapper">
                        <h3 className="h-font">Sign up</h3>
                        <ul className="social-auth">
                            <li><a href="#" className="btn-style icon transparent"><img src={googleIcon} alt="icon" />Sign in with Google</a></li>
                            {/* <li><a href="#" className="btn-style icon transparent"><img src={microsoftIcon} alt="icon" />Sign in with Microsoft</a></li> */}
                        </ul>
                        <div className="form auth-form">
                            <div className="form-group">
                                <label htmlFor="full-name">Name</label>
                                <input type="text" id="full-name" className="form-control" placeholder="Insert name here..." />
                            </div>
                            <div className="form-group submit">
                                <Link to="/login" className="btn-style full dark">Create Account</Link>
                                <div className="no-account">
                                    <p className="f-12 w-600">Already have an account? <Link to="/login" className="f-12 w-600">Login</Link></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default OtcTrade
